import React, { useState } from 'react';
import { FaPlusCircle } from "react-icons/fa";
import {
    Button,
    Form,
    Modal,
    Select,
    Row,
    Col,
    InputNumber,
    DatePicker,
    Radio,
    message,
    // Statistic,
    // Typography,
    Divider
} from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';
// import dayjs from 'dayjs';


function AddProduct({ courses, products, order, form }) {

    const [selectType, setSelectType] = useState('courses');
    const [open, setOpen] = useState(false);
    const [formOrderItem] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();
    const { mutate, isLoading } = useMutation({
        mutationFn: (data) => {
            axios
                .post(`/api/orderItems/`, data)
                .then((res) => {
                    const isVat = form.getFieldValue('is_vat');
                    const grand_total = form.getFieldValue('grand_total') + res.data.price * res.data.quantity;
                    let vat = 0;
                    let total = form.getFieldValue('grand_total') + res.data.price * res.data.quantity;
                    if (isVat) {
                        total = (form.getFieldValue('grand_total') + res.data.price * res.data.quantity) / 1.07
                        vat = grand_total - total
                    }
                    form.setFieldsValue({
                        total,
                        vat,
                        grand_total
                    });
                    formOrderItem.resetFields();
                    messageApi.open({
                        type: 'success',
                        content: 'Item has been created.',
                        duration: 1,
                        onClose: () => {
                            queryClient.invalidateQueries([`/api/orderItems/getOrderDetail/${order}`]);
                            setOpen(false);
                        }
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Something went wrong please check you data or contact Admin.',
                    });
                })
        },
    });


    const onCreate = () => {
        formOrderItem
            .validateFields()
            .then(values => {

                const payload = {
                    ...values,
                    order,
                    start_date: values.start_date
                        ? values.start_date.format("YYYY-MM-DD")
                        : null,
                    end_date: values.end_date
                        ? values.end_date.format("YYYY-MM-DD")
                        : null
                };

                mutate(payload);

            })
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'Something went wrong please check you data or contact Admin.',
                });
            })
    };

    const onSelectProductType = (e) => {
        formOrderItem.resetFields()
        setSelectType(e.target.value);
    };


    const onCancelCreate = () => {
        setOpen(false);
    }

    const onSelectCourse = (value, option) => {
        // console.log('value; ', value);
        // console.log('option; ', option);
        const course = courses.find(f => f._id === value)

        formOrderItem.setFieldsValue({
            price: course.price,
            // selling_price: selectProduct.selling_price - form.getFieldValue('discount'),
        });
    }
    const onSelectProduct = (value, option) => {
        // console.log('value; ', value);
        // console.log('option; ', option);
        const product = products.find(f => f._id === value)
        formOrderItem.setFieldsValue({
            price: product.price,
        });
    }

    return (
        <div>
            {contextHolder}
            <Row justify="end">
                <Col>
                    <Button
                        type='primary'
                        icon={<FaPlusCircle />}
                        onClick={() => setOpen(true)}
                    >Add Products</Button>
                </Col>
            </Row>
            <Modal
                open={open}
                title="Select Items"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        Ok
                    </Button>
                ]}
            >
                <Radio.Group onChange={onSelectProductType} value={selectType}>
                    <Radio value={'courses'}>Courses</Radio>
                    <Radio value={'others'}>Products</Radio>
                </Radio.Group>
                <Divider />
                <Form
                    form={formOrderItem}
                    layout="vertical"
                    name='addProduct'
                    initialValues={{
                        quantity: 1,
                    }}
                >
                    {selectType === 'courses' && <Form.Item
                        name="product"
                        label="Courses"
                        rules={[
                            {
                                required: true,
                                message: 'Please input data!',
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="children"
                            onSelect={onSelectCourse}
                        >
                            {courses.map((course) => (
                                <Select.Option key={course._id} value={course._id} >
                                    {course.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>}
                    {selectType === 'courses' && <Row gutter={[16, 16]}>
                        <Col xs={12}>
                            <Form.Item
                                name="start_date"
                                label="Begin Date"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input data!',
                                    },
                                ]}
                            >
                                <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                name="end_date"
                                label="End Date"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input data!',
                                    },
                                ]}
                            >
                                <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                            </Form.Item>
                        </Col>
                    </Row>}

                    {selectType === 'others' && <Form.Item
                        name="product"
                        label="Products"
                        rules={[
                            {
                                required: true,
                                message: 'Please input data!',
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="children"
                            onSelect={onSelectProduct}
                        >
                            {products.map((product) => (
                                <Select.Option key={product._id} value={product._id} >
                                    {product.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>}
                    <Row gutter={[16, 16]}>
                        <Col xs={12}>
                            <Form.Item
                                name="price"
                                label="Price"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input data!',
                                    },
                                ]}
                            >
                                <InputNumber style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item
                                name="quantity"
                                label="Quantity"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input data!',
                                    },
                                ]}
                            >
                                <InputNumber style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>
    )
}

export default AddProduct